import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { DASHBOARD_STUDENT, DASHBOARD_V2_STUDENT } from '../constants/actionTypes'
import * as API from '../constants/api'

export const dashboardStudent = createAsyncThunk(
  DASHBOARD_STUDENT,
  async (params: PayloadCreatorParams<`${typeof API.DASHBOARD_STUDENT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.dashboardStudent(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const dashboardStudentClear = createAction(`${DASHBOARD_STUDENT}/clear`)

export const dashboardV2Student = createAsyncThunk(
  DASHBOARD_V2_STUDENT,
  async (params: PayloadCreatorParams<`${typeof API.DASHBOARD_V2_STUDENT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.dashboardV2Student(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const dashboardV2StudentClear = createAction(`${DASHBOARD_V2_STUDENT}/clear`)
